
<div class="flow-auth-box-container">
	<div v-if="$slots['logo']" class="flow-auth-logo">
		<slot name="logo" />
	</div>
	<div class="flow-auth-box">
		<slot />
	</div>
	<div class="flow-auth-box-footer">
		<slot name="footer" />
	</div>
</div>
